// api
import type { GetAlarmDto } from '@/api/generated/recalc/endpoints/v2/alarms';

// feature-utils
import { isEnergyXplorerAlarmType } from '@/features/energyxplorer/utils/energyXplorerAlarmTypes';

const getAlarmEnergyGroupIds = (alarm: GetAlarmDto): number[] =>
  alarm.associations?.energyGroups
    ?.map((energyGroup) => energyGroup.id)
    .filter((groupId): groupId is number => typeof groupId === 'number') ?? [];

const hasMatchingEnergyGroup = (
  alarm: GetAlarmDto,
  energyGroupIds: number[],
): boolean => {
  if (!energyGroupIds.length) {
    return false;
  }

  return getAlarmEnergyGroupIds(alarm).some((groupId) =>
    energyGroupIds.includes(groupId),
  );
};

export const isPortfolioAlarm = (
  alarm: GetAlarmDto,
  portfolioGroupIds: number[],
): boolean => {
  if (alarm.alarmType === undefined || alarm.alarmType === null) {
    return false;
  }

  return (
    isEnergyXplorerAlarmType(alarm.alarmType) &&
    hasMatchingEnergyGroup(alarm, portfolioGroupIds)
  );
};

export const isDeepDiveAlarm = (
  alarm: GetAlarmDto,
  deepDiveGroupIds: number[],
): boolean => {
  if (alarm.alarmType === undefined || alarm.alarmType === null) {
    return false;
  }

  return (
    isEnergyXplorerAlarmType(alarm.alarmType) &&
    hasMatchingEnergyGroup(alarm, deepDiveGroupIds)
  );
};

export const filterPortfolioAlarms = (
  alarms: GetAlarmDto[],
  portfolioGroupIds: number[],
): GetAlarmDto[] =>
  alarms.filter((alarm) => isPortfolioAlarm(alarm, portfolioGroupIds));

export const filterDeepDiveAlarms = (
  alarms: GetAlarmDto[],
  deepDiveGroupIds: number[],
): GetAlarmDto[] =>
  alarms.filter((alarm) => isDeepDiveAlarm(alarm, deepDiveGroupIds));
